import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "flex flex-col mb-3 gap-3" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "flex justify-end pt-3" }
const _hoisted_5 = { class: "flex flex-col mb-3 gap-3" }
const _hoisted_6 = { class: "flex flex-col grow" }
const _hoisted_7 = {
  key: 0,
  class: "grid grid-cols-1 gap-3"
}
const _hoisted_8 = {
  key: 1,
  class: "grid grid-cols-1 gap-3"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "flex justify-end pt-3" }
const _hoisted_11 = { class: "m-auto px-8 md:px-20 pb-8" }
const _hoisted_12 = { class: "pt-3" }
const _hoisted_13 = { class: "py-10 flex justify-between" }
const _hoisted_14 = { class: "flex gap-3" }
const _hoisted_15 = { class: "m-auto" }
const _hoisted_16 = { class: "flex justify-between items-end mb-3" }
const _hoisted_17 = { class: "text-xl font-bold" }
const _hoisted_18 = { class: "text-sm" }
const _hoisted_19 = { class: "grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3 overflow-x-auto mb-5" }
const _hoisted_20 = { class: "grid grid-cols-4 w-full" }
const _hoisted_21 = { class: "text-sm font-bold" }
const _hoisted_22 = { class: "flex w-full justify-end" }
const _hoisted_23 = { class: "flex justify-end mb-3" }
const _hoisted_24 = { class: "flex justify-end" }
const _hoisted_25 = { class: "rotate-x-180 overflow-x-scroll" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  colspan: "3",
  class: "px-2 bg-transparent border-b-2 border-b-next-gray-md-dark"
}
const _hoisted_31 = { class: "px-2 bg-transparent text-right border-b-2 border-b-next-gray-md-dark" }
const _hoisted_32 = {
  colspan: "7",
  class: "px-2 bg-transparent border-b-2 border-b-next-gray-md-dark"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_ModalPianoFatturazione = _resolveComponent("ModalPianoFatturazione")!
  const _component_Field = _resolveComponent("Field")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_BadgeStato = _resolveComponent("BadgeStato")!
  const _component_CardDivisorioGrigio = _resolveComponent("CardDivisorioGrigio")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_ConfirmDelete = _resolveComponent("ConfirmDelete")!
  const _component_TabellaContextMenu = _resolveComponent("TabellaContextMenu")!
  const _component_NextTable = _resolveComponent("NextTable")!
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Loading, {
        visible: _ctx.pianoDiFatturazione.loading
      }, null, 8, ["visible"])
    ])),
    _createVNode(_component_ModalPianoFatturazione, {
      visible: _ctx.modal_visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modal_visible) = $event)),
      contatoriIva: _ctx.ContatoriIva,
      onSave: _ctx.onSave,
      sottoprogetto_id: _ctx.id,
      errors: _ctx.errors,
      row_model: _ctx.row_model,
      versione: _ctx.versione
    }, null, 8, ["visible", "contatoriIva", "onSave", "sottoprogetto_id", "errors", "row_model", "versione"]),
    _createVNode(_component_Modal, {
      visible: _ctx.modal_contratto_visible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modal_contratto_visible) = $event)),
      backdrop: true
    }, {
      header: _withCtx(() => _cache[17] || (_cache[17] = [
        _createElementVNode("div", null, [
          _createElementVNode("h2", { class: "text-lg font-bold mb-3" }, "Dati contrattuali")
        ], -1)
      ])),
      main: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Field, {
              modelValue: _ctx.numero_contratto_model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.numero_contratto_model) = $event)),
              field_name: "Numero contratto",
              placeholder: "N contratto",
              errors: _ctx.getErrorsContratto('pdf_numero_contratto')
            }, null, 8, ["modelValue", "errors"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Field, {
              modelValue: _ctx.data_contratto_model,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data_contratto_model) = $event)),
              field_name: "Data contratto",
              type: "date",
              placeholder: "Data contratto",
              errors: _ctx.getErrorsContratto('pdf_data_contratto')
            }, null, 8, ["modelValue", "errors"])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_NextButton, {
            variant: "outline-secondary",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modal_contratto_visible=false)),
            class: "col-start-3 py-2 px-4"
          }, {
            default: _withCtx(() => _cache[18] || (_cache[18] = [
              _createTextVNode(" Chiudi ")
            ])),
            _: 1
          }),
          _createVNode(_component_NextButton, {
            variant: "primary",
            onClick: _ctx.onSaveDatiContrattuali,
            class: "ml-4 py-2 px-4"
          }, {
            default: _withCtx(() => _cache[19] || (_cache[19] = [
              _createTextVNode(" Salva ")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Modal, {
      visible: _ctx.modal_stato_visible,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.modal_stato_visible) = $event)),
      backdrop: true
    }, {
      header: _withCtx(() => _cache[20] || (_cache[20] = [])),
      main: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Field, {
            modelValue: _ctx.numero_contratto_model,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.numero_contratto_model) = $event)),
            field_name: "Stato",
            errors: _ctx.getErrorsStato('stato')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                modelValue: _ctx.stato_model,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.stato_model) = $event)),
                options: _ctx.statoPianificazioneAutocomplete.options,
                loading: _ctx.statoPianificazioneAutocomplete.isLoading,
                onSearchChange: _ctx.statoPianificazioneAutocomplete.search,
                class: "next-vue-multiselect-single",
                "close-on-select": true,
                "clear-on-select": false,
                deselectLabel: "Deseleziona",
                selectedLabel: "Selezionato",
                selectLabel: "Seleziona",
                "track-by": "id",
                label: "text"
              }, null, 8, ["modelValue", "options", "loading", "onSearchChange"])
            ]),
            _: 1
          }, 8, ["modelValue", "errors"]),
          (_ctx.stato_model.id == 2)
            ? (_openBlock(), _createBlock(_component_Field, {
                key: 0,
                labelVisible: false,
                errors: _ctx.getErrorsStato('allegato')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_FileUpload, {
                    uploaded_files: _ctx.uploaded_files,
                    "onUpdate:uploaded_files": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.uploaded_files) = $event)),
                    model_files: _ctx.model_files,
                    "onUpdate:model_files": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model_files) = $event)),
                    to_delete: _ctx.to_delete,
                    "onUpdate:to_delete": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.to_delete) = $event)),
                    accept: ".pdf,.doc,.docx,.eml,.jpg,.jpeg,.png,.csv,.txt,.xlx,.xls,.xlsx"
                  }, {
                    default: _withCtx(({props, methods}) => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_NextButton, {
                          variant: "outline-secondary",
                          onClick: methods.open,
                          class: "w-full h-10 px-4 grow"
                        }, {
                          default: _withCtx(() => _cache[21] || (_cache[21] = [
                            _createElementVNode("i", { class: "icon icon-graffetta" }, null, -1),
                            _createTextVNode(" Allega ")
                          ])),
                          _: 2
                        }, 1032, ["onClick"]),
                        (props.to_upload)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.to_upload, (f, idx) => {
                                return (_openBlock(), _createElementBlock("a", {
                                  class: "underline text-sm text-next-atp pt-3",
                                  key: idx
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(f.name), 1)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.uploaded_files)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploaded_files, (f, idx) => {
                                return (_openBlock(), _createElementBlock("a", {
                                  class: "underline text-sm text-next-atp pt-3 cursor-pointer",
                                  onClick: ($event: any) => (_ctx.downloadFile(f?.id)),
                                  target: "_blank",
                                  key: idx
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(f.name), 1)
                                ], 8, _hoisted_9))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["uploaded_files", "model_files", "to_delete"])
                ]),
                _: 1
              }, 8, ["errors"]))
            : _createCommentVNode("", true)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_NextButton, {
            variant: "outline-secondary",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.modal_stato_visible=false)),
            class: "col-start-3 py-2 px-4"
          }, {
            default: _withCtx(() => _cache[22] || (_cache[22] = [
              _createTextVNode(" Chiudi ")
            ])),
            _: 1
          }),
          _createVNode(_component_NextButton, {
            variant: "primary",
            onClick: _ctx.setStato,
            class: "ml-4 py-2 px-4"
          }, {
            default: _withCtx(() => _cache[23] || (_cache[23] = [
              _createTextVNode(" Salva ")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _cache[38] || (_cache[38] = _createElementVNode("div", { id: "selectModal" }, null, -1)),
    _createElementVNode("div", _hoisted_11, [
      _withDirectives(_createElementVNode("div", _hoisted_12, [
        _createVNode(_component_Alert, null, {
          default: _withCtx(() => _cache[24] || (_cache[24] = [
            _createTextVNode("Gli ordini di vendita hanno valute differenti")
          ])),
          _: 1
        })
      ], 512), [
        [_vShow, !_ctx.StessaValutaVendita]
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_Breadcrumbs, { paths: _ctx.getBreadcrumbsPath }, null, 8, ["paths"]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_BadgeStato, {
            stato: _ctx.stato_gamma?.PD0C_STATO_PD1E,
            class: "whitespace-nowrap flex items-center"
          }, null, 8, ["stato"]),
          _createVNode(_component_VueMultiselect, {
            modelValue: _ctx.versione,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.versione) = $event)),
            options: _ctx.versioni,
            class: "next-vue-multiselect-single w-80",
            deselectLabel: "",
            selectedLabel: "",
            selectLabel: "",
            label: "version"
          }, {
            option: _withCtx(({option, props}) => [
              _createTextVNode(" Versione " + _toDisplayString(option?.version) + " del " + _toDisplayString(_ctx.$filters.toDate(option?.created_at)) + " alle " + _toDisplayString(_ctx.$filters.toTime(option?.created_at)), 1)
            ]),
            singleLabel: _withCtx(({option, props}) => [
              _createTextVNode(" Versione " + _toDisplayString(option?.version) + " del " + _toDisplayString(_ctx.$filters.toDate(option?.created_at)) + " alle " + _toDisplayString(_ctx.$filters.toTime(option?.created_at)), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "options"])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        (_ctx.error_message)
          ? (_openBlock(), _createBlock(_component_Alert, {
              key: 0,
              dismissable: true,
              onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.error_message = '')),
              class: "bg-next-orange drop-shadow-lg w-96 fixed top-5 right-5 z-50"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.error_message), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("h2", _hoisted_17, "Sottoprogetto: " + _toDisplayString(_ctx.Sottoprogetto?.titolo), 1),
          _createElementVNode("div", _hoisted_18, "ID progetto: " + _toDisplayString(_ctx.progetto?.id_gamma) + " / Codice commessa: " + _toDisplayString(_ctx.Sottoprogetto?.cod_nodo), 1)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_CardDivisorioGrigio, null, {
            top: _withCtx(() => _cache[25] || (_cache[25] = [
              _createElementVNode("div", { class: "text-sm" }, [
                _createElementVNode("b", null, "Budget di progetto")
              ], -1)
            ])),
            bottom: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.NonConforme ? '---' : _ctx.RicaviValuta.toCurrencyString()) + " " + _toDisplayString(_ctx.valutaLabel) + " ", 1),
              _withDirectives(_createElementVNode("span", null, " / " + _toDisplayString(_ctx.Ricavi.toCurrencyString()) + " €", 513), [
                [_vShow, _ctx.Valuta]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_CardDivisorioGrigio, null, {
            top: _withCtx(() => _cache[26] || (_cache[26] = [
              _createElementVNode("div", { class: "text-sm" }, [
                _createElementVNode("b", null, "Pianificato")
              ], -1)
            ])),
            bottom: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Pianificato.toCurrencyString()) + " " + _toDisplayString(_ctx.valutaLabel) + " ", 1),
              _withDirectives(_createElementVNode("span", null, " / " + _toDisplayString(_ctx.PianificatoEuro.toCurrencyString()) + " €", 513), [
                [_vShow, _ctx.Valuta]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_CardDivisorioGrigio, null, {
            top: _withCtx(() => _cache[27] || (_cache[27] = [
              _createElementVNode("div", { class: "text-sm" }, [
                _createElementVNode("b", null, "Residuo")
              ], -1)
            ])),
            bottom: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.NonConforme ? '---' : _ctx.Residuo.toCurrencyString()) + " " + _toDisplayString(_ctx.valutaLabel) + " ", 1),
              _withDirectives(_createElementVNode("span", null, " / " + _toDisplayString(_ctx.ResiduoEuro.toCurrencyString()) + " €", 513), [
                [_vShow, _ctx.Valuta]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_CardDivisorioGrigio, { class: "col-span-2" }, {
            top: _withCtx(() => _cache[28] || (_cache[28] = [
              _createElementVNode("div", { class: "text-sm" }, [
                _createElementVNode("b", null, "Contatori per iva")
              ], -1)
            ])),
            bottom: _withCtx(() => [
              _createElementVNode("div", _hoisted_20, [
                _cache[29] || (_cache[29] = _createElementVNode("p", { class: "font-bold" }, "IVA", -1)),
                _cache[30] || (_cache[30] = _createElementVNode("p", { class: "font-bold" }, "Totale", -1)),
                _cache[31] || (_cache[31] = _createElementVNode("p", { class: "font-bold" }, "Pianificato", -1)),
                _cache[32] || (_cache[32] = _createElementVNode("p", { class: "font-bold" }, "Residuo", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ContatoriIva, (v, i) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    _createElementVNode("p", null, _toDisplayString(v.descrizione), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$filters.toCurrency(v.totale_ricavi)), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$filters.toCurrency(v.pianificato)), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$filters.toCurrency(v.totale_ricavi - v.pianificato)), 1)
                  ], 64))
                }), 256))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_CardDivisorioGrigio, { class: "col-start-6" }, {
            top: _withCtx(() => [
              _createElementVNode("div", _hoisted_21, "Data: " + _toDisplayString(_ctx.$filters.toDate(_ctx.data_contratto)) + " - Numero: " + _toDisplayString(_ctx.numero_contratto || '---'), 1)
            ]),
            bottom: _withCtx(() => [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_NextButton, {
                  variant: "primary",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.modal_contratto_visible = true)),
                  class: "py-2 px-4"
                }, {
                  default: _withCtx(() => _cache[33] || (_cache[33] = [
                    _createTextVNode(" Dati contratto ")
                  ])),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_NextButton, {
            variant: "primary",
            onClick: _ctx.addOdv,
            class: "px-3 py-2"
          }, {
            default: _withCtx(() => _cache[34] || (_cache[34] = [
              _createTextVNode("Aggiungi riga di pianificazione ")
            ])),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_Paginator, {
            class: "",
            pagination: _ctx.pianoDiFatturazione.paginate
          }, null, 8, ["pagination"])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_NextTable, {
            class: "rotate-x-180 table-fixed w-full border-separate border-spacing-1 py-4",
            cols: _ctx.righeCols,
            "onUpdate:cols": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.righeCols) = $event)),
            rows: _ctx.pianoDiFatturazione.rows,
            onOrderUpdate: _ctx.pianoDiFatturazione.updateCols
          }, _createSlots({ _: 2 }, [
            _renderList(_ctx.pianoDiFatturazione.rows, (c, j) => {
              return {
                name: `td_${j}_2`,
                fn: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.toDate(c.data_emissione_fattura)), 1)
                ])
              }
            }),
            _renderList(_ctx.pianoDiFatturazione.rows, (c, j) => {
              return {
                name: `td_${j}_3`,
                fn: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.toCurrency(_ctx.PercentualeRighePianoDiFatturazione(c.righe))) + " % ", 1)
                ])
              }
            }),
            _renderList(_ctx.pianoDiFatturazione.rows, (c, j) => {
              return {
                name: `td_${j}_4`,
                fn: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.toCurrency(_ctx.TotaleRighePianoDiFatturazione(c.righe))), 1)
                ])
              }
            }),
            _renderList(_ctx.pianoDiFatturazione.rows, (c, j) => {
              return {
                name: `td_${j}_10`,
                fn: _withCtx(({context}) => [
                  _createElementVNode("div", {
                    class: "grow self-center",
                    onClick: ($event: any) => (_ctx.initModalStato(c))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.statoPianificazioneManager.stati.find(el => el.id == context.row[context.cell.prop])?.text) + " ", 1),
                    (context.row?.allegato_file_id)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: [
                            _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"])),
                            ($event: any) => (_ctx.downloadFile(context.row?.allegato_file_id))
                          ],
                          class: "block underline text-sm text-next-atp whitespace-nowrap cursor-pointer"
                        }, " Scarica allegato ", 8, _hoisted_27))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_26)
                ])
              }
            }),
            _renderList(_ctx.pianoDiFatturazione.rows, (c, j) => {
              return {
                name: `td_${j}_0`,
                fn: _withCtx((context) => [
                  _createVNode(_component_TabellaContextMenu, {
                    menuClass: "shadow absolute flex flex-col text-left whitespace-nowrap cursor-pointer p-3 bg-white",
                    buttonClass: "bg-next-gray-md-dark cursor-pointer block text-center absolute inset-0 flex items-center justify-center hover:bg-next-orange",
                    context: c,
                    id: j,
                    teleport_to: "#modal",
                    cmOpener: _ctx.cmOpener
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        onClick: ($event: any) => (_ctx.duplicaRiga(c)),
                        class: "w-full hover:text-next-neu mb-2"
                      }, "Duplica", 8, _hoisted_28),
                      _createElementVNode("span", {
                        onClick: ($event: any) => (_ctx.modificaRiga(c)),
                        class: "w-full hover:text-next-neu mb-2"
                      }, "Modifica", 8, _hoisted_29),
                      _createVNode(_component_ConfirmDelete, {
                        position: "right",
                        onCancella: ($event: any) => (_ctx.cancellaRiga(c))
                      }, {
                        default: _withCtx(() => _cache[35] || (_cache[35] = [
                          _createElementVNode("span", { class: "cursor-pointer hover:text-next-neu" }, "Elimina", -1)
                        ])),
                        _: 2
                      }, 1032, ["onCancella"])
                    ]),
                    _: 2
                  }, 1032, ["context", "id", "cmOpener"])
                ])
              }
            }),
            _renderList(_ctx.pianoDiFatturazione.rows, (c, j) => {
              return {
                name: `td_child_${j}`,
                fn: _withCtx(({context}) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(context.row.righe, (cc, i) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: i,
                      class: "h-5 text-sm"
                    }, [
                      _cache[36] || (_cache[36] = _createElementVNode("td", null, null, -1)),
                      _createElementVNode("td", _hoisted_30, _toDisplayString(cc.iva.descrizione), 1),
                      _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(cc.valore))), 1),
                      _createElementVNode("td", _hoisted_32, _toDisplayString(cc.note), 1)
                    ]))
                  }), 128))
                ])
              }
            })
          ]), 1032, ["cols", "rows", "onOrderUpdate"])
        ]),
        _createVNode(_component_InfiniteLoading, {
          onInfinite: _ctx.pianoDiFatturazione.fetchNextPage,
          identifier: _ctx.pianoDiFatturazione.infiniteIdentifier,
          style: {"min-height":"1px"}
        }, {
          complete: _withCtx(() => _cache[37] || (_cache[37] = [
            _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altre righe.", -1)
          ])),
          _: 1
        }, 8, ["onInfinite", "identifier"])
      ])
    ])
  ], 64))
}